import e from "react";
import o from "@appchoose/cn";
const a = ({
  className: t,
  ...r
}) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    className: o("animate-spin-fast text-green-900", t),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ...r
  },
  /* @__PURE__ */ e.createElement("circle", { cx: "16", cy: "16", r: "15", stroke: "#ECECEC", strokeWidth: "2" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 1C17.9698 1 19.9204 1.38799 21.7403 2.14181C23.5601 2.89563 25.2137 4.00052 26.6066 5.3934C27.9995 6.78628 29.1044 8.43987 29.8582 10.2598C30.612 12.0796 31 14.0302 31 16",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  )
);
a.displayName = "Loader";
export {
  a as default
};
